<template>
<div class="mh100vh b_fff">
  <div class="pt20 pl24 pr24">

      <div v-if="list.length > 0" class="b_fff bdrd8 bsh1">
        <div v-for="(v,k) in list" class="lnb df aic pl24 pr24 pt30 pb30">
          <img v-if="v.photo" :src="v.photo" alt="" class="db all87 bdrd50p">
          <img v-else src="./assets/img/p.png" alt="" class="db all87 bdrd50p">
          <div class="pl16 fx1">
            <div class="fz30 c_333">{{v.nickname}}</div>
            <div class="fz24 c_999">{{v.tel.substr(0,3)+'****'+v.tel.substr(v.tel.length-4,4)}}</div>
          </div>
          <div>
            <div class="fz40 c_333 tar"><span class="fz28">总提供收益：</span>{{v.yongjin}}元</div>
            <div class="c_666 fz24 tar">邀请时间：{{v.created_at}}</div>
          </div>
        </div>
      </div>
      <div v-else class="fz26 c_ccc pt40 tac">暂无数据</div>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
  </div>
</div>
</template>

<script>
import weui from 'weui.js'
import infiniteScroll from '@/basic/infiniteScroll'
export default {
  directives: {infiniteScroll},
  data(){
    return{
      account:{},
      info:{},
      list:[],
      busy: true,
      load:true,
      page:1,
      type:1
    }
  },
  mounted() {
    this.getAccount();
  },
  methods:{
    getAccount(){
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
        vm.getLog();
      })
    },
    getLog(flag){
      let vm = this;
      let url = "account/invite"
      vm.ajax(url, "get", 'page='+vm.page, e => {
        vm.load = false;
        if(e.data.list){
          if(flag){
            vm.list =  vm.list.concat(e.data.list)
            if(e.data.count == vm.page){
                vm.busy = true;
            }else{
                vm.busy = false;
            }
          }else{
            vm.list =  e.data.list;
            if(vm.list.length < e.data.limit){
              vm.busy = true;
            }else{
              vm.busy = false;
            }
          }
        }else{
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
          vm.page++;
          vm.getAccountPointLog(true);
      }, 1000);
    }
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/invitation.vue